import Status from "./Status";

export default new Status();
